import { Navigate, useLocation } from "react-router-dom";

import { RVRoutingPage } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";

import { AudienceSubNav } from "./Components/AudienceSubNav/AudienceSubNav";
import { audiencePathResources } from "./Pages/audiencePaths";
export default function AudienceRoutingPage(): JSX.Element {
    return <RVRoutingPage nav={<AudienceSubNav />} />;
}

export function AudienceRerouter(): JSX.Element {
    const location = useLocation();
    const newPath = `${AppPagePaths.audience}/${audiencePathResources.contacts}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
